module.exports = __webpack_public_path__ + "media/torsten1.63a5fc41.mp3";